import * as api from '../../api';
import { getCustomerGuid } from "../../customer";
import {formatNumber, getCdnImageUrl, renderItems} from "../../functions";

export const selectChild = function () {

	var children = api.getData(
		'get-children',
		{ guid: getCustomerGuid() },
		{ async: false }
	).responseJSON

	var subscriptions = api.getData(
		'get-list-subscriptions',
		{ guid: getCustomerGuid() },
		{ async: false }
	).responseJSON;

	var inputs = [];
	children.forEach(function (child) {
		inputs.push(`<input type="radio" id="child_${child.id}" name="child" value="${child.id}"><label for="child_${child.id}" class="sub-order-card"><span>${child.name}</span> <a href="#" class="remove-child" data-id="${child.id}">x</a> </label>`);
	});

	var options = [];
	subscriptions.forEach(function (sub) {
		options.push(`<option id="child_${sub.id}" value="${sub.id}">Přidat do existujícího předplatného (${new Date(sub.date).toLocaleDateString('CS')}) - každých ${sub.period} dní</label>`)
	})

	var selectSubscription = '';
	if (subscriptions.length > 0) {
		selectSubscription = `<div class="sub-order-select-subscription" style="margin-bottom: 20px">
		                    <h4>Máte již aktivní předplatné</h4>
		                    <p>
		                     Zvolte zda chcete pouze rozšířit stávající předplatné či založit nové.
		                    </p>
		                    <select id="select-subscription">
		                        <option value="">Založit nové přeplatné</option>
		                        ${options.join('')}
		                     </select>
	                     </div>`;
	}

	return ` <div id="sub-step1">
	                <form id="add-subscription-form" class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="${getCdnImageUrl(`/user/documents/upload/subimg/cross.svg`)}">
	                     </button>
	                    <h3>Vyberte dítě pro které předplatné chcete</h3>
	                    
	                     
	                     <p id="show-error-msg" style="display: none">Musíte si zvolit vaše dítě, nebo si přidat další</p>
	                    <div class="sub-order-cards">
	                        
	                        ${inputs.join('')}
	                        
	                        <input type="hidden" name="quantity" value="1" />
	                        <button type="button" class="addChild">Přidat nové dítě</button>
	                       
	                    </div>
	                    
	                     ${selectSubscription}
	                    
	                   
	                     
	                     
	                    <button type="submit" id="subscription-next-step" class="subscription-button">Přidat do předplatného</button>
	                    
	                </form>
	            </div>`
}


$(document).on("submit", "#add-subscription-form",function(e) {
	e.preventDefault();

	var form = $('#add-subscription-form')
	var childId = form.find('[name="child"]:checked').val();
	$('#show-error-msg').hide();
	if(form.find('[name="child"]:checked').length === 0){
		$('#show-error-msg').show();
		return;
	}

	var productCode = dataLayer[0].shoptet.product.code;
	var quantity = form.find('[name="quantity"]').val();
	var subscriptionId = $('#select-subscription').length ? $('#select-subscription').val() : '';
	showSpinner();
	api.postData(
		'add-to-cart',
		{ childId, productCode, quantity, subscriptionId: subscriptionId ? subscriptionId : null },
		{ guid: getCustomerGuid() }
	).done(function (data) {
		$('#sub-overlay').hide();

		if (subscriptionId) {
			showMessage('Položka byla přidána do předplatného HomeBoxu. Přidáný produkt můžete zkontrolovat v <a href="/klient/#subscription#">administraci přeplatného</a', 'notice');
			return;
		}

		if(data.totalQuantity > 0) {
			api.getData('get-mini-cart', {guid: getCustomerGuid()})
				.done(function (data) {
					showMessage('Položka byla úspěšně přidána do předplatného', 'notice');
					$('#subscription-cart-wrapper').removeClass('hide');
					$('#subscription-cart-wrapper .header-cart-count span').text(data.totalQuantity);
					$('#subscription-recapitulation #sub-items').html(renderItems(data.data));
					$('#subscription-recapitulation #sub-total-price').html(formatNumber(data.totalPrice) + " kč");
				})
		} else {
			showMessage('Položku se nepodařilo přidat do předplatného.', 'error');
		}
	}).always(function () {
		hideSpinner();
	});
})

$(document).on('click', '.addChild', function (e) {
	e.preventDefault();
	$('#sub-step1').hide();
	$('#sub-step2').show();
})

$(document).on('click', '#add-subscription-form .remove-child', function (e) {
	e.preventDefault();
	var $this = $(this);
	showSpinner();
	api.getData(
		'remove-child',
		{ guid: getCustomerGuid(), childId: $this.data('id') },
	).done(function () {
		hideSpinner();
		$this.closest('label').remove();
	}).fail(function() {
		hideSpinner();
		alert("Dítě nemůže být smazáno jelikož má již vytvořené předplatné.");
	});
})


